import { useEffect, useRef, useState } from "react";
import { fileToBase64, isEmpty } from "../../tools/tools";
import FileResizer from "react-image-file-resizer";
import "./resizeImg.scss";
import { Image, Tooltip, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
const ResizeImages = ({ exportImage, value = "", disabled = false, idelem = new Date().getTime(), style = {} }) => {
  const [tempImage, setTempImage] = useState();
  const fileInputRef = useRef(null);

  const [disabledImage, setDisabledImage] = useState(false);

  useEffect(() => {
    setDisabledImage(disabled);
  }, [disabled]);

  useEffect(() => {
    const callIntialImage = async () => {
      const tempImg = await fileToBase64(value);
      setTempImage(tempImg);
    };
    if (value?.size > 0) {
      callIntialImage();
    }
  }, [value]);

  const resize = async ({ file, maxWidth = 1500, maxHeight = 1500 }) => {
    return new Promise((resolve, reject) => {
      try {
        let maxSize = parseInt(process.env.REACT_APP_MAX_SIZE_IMAGE) * 1024;
        if (file?.size <= maxSize) {
          resolve(file);
        } else {
          FileResizer.imageFileResizer(
            file,
            maxWidth,
            maxHeight,
            "JPEG",
            100,
            0,
            async (uri) => {
              if (uri.size <= maxSize) {
                resolve(uri);
              } else {
                return resolve(await resize({ file: uri, maxHeight: maxHeight / 2, maxWidth: maxWidth / 2 }));
              }
            },
            "file",
          );
        }
      } catch (error) {
        reject(null);
      }
    });
  };

  const handleChangeFileCert = async (e) => {
    try {
      let resFile = await resize({ file: e.target.files[0] });
      if (resFile) {
        const tempImg = await fileToBase64(resFile);
        setTempImage(tempImg);
        exportImage(resFile);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleClear = () => {
    setTempImage("");
  };
  return (
    <>
      <div className={`uploadDocument ${disabledImage ? "disabled" : ""} `}>
        {isEmpty(tempImage) ? (
          <>
            <label className={"lbl_overly"} htmlFor={`fileInput${idelem}`}>
              <input
                ref={fileInputRef}
                type="file"
                id={`fileInput${idelem}`}
                disabled={disabledImage}
                accept="image/jpeg, image/png"
                onChange={handleChangeFileCert}
              />
            </label>
            <div className={"ant_upload"}>
              <div className={"holder_upload_document"}>
                <p className={"ant_upload_hint"}>
                  <span>تصویر مربوطه را تنها با فرمت های</span> <span>JPEG</span>
                  <span> یا </span>
                  <span>PNG</span> <span>بارگذاری نمایید</span>
                </p>
                <label className={"lbl_btn"}>انتخاب فایل</label>
              </div>
            </div>
          </>
        ) : (
          <Image
            src={tempImage}
            preview={{
              mask: (
                <>
                  <div className={"holder_action_img"}>
                    <Tooltip title="حذف">
                      <Button className="btn-normal" onClick={handleClear}>
                        <DeleteOutlined />
                      </Button>
                    </Tooltip>
                  </div>
                </>
              ),
            }}
          />
        )}
      </div>
    </>
  );
};

export default ResizeImages;
